import { UserProps } from '@elsevier-health/osmosis-shared/types/user';
import { sha256 } from './crypto';

/**
 * Updates GTM user and experiment fields. The shared document head owns loading
 * the container, independently of user and location initialization.
 */
export const gtmInitializer = async (user?: UserProps | null) => {
  if (typeof document === 'undefined') return;

  const loggedIn = !!user?.userID;
  const needsLogin = false;
  const hashedUserID = user?.userID ? await sha256(user.userID.toString()) : '';
  const hashedEmail = user?.email ? await sha256(user.email.toLowerCase()) : '';
  const dataLayerArgs = {
    loggedIn,
    needsLogin,
    userID: hashedUserID,
    email: hashedEmail,
  };

  globalThis.dataLayer = globalThis.dataLayer || [];

  try {
    let tests = Object.entries(localStorage)
      .filter(([key, value]) => key.startsWith('Test:'))
      .reduce((memo: { name: string; group: any }[], [key, value]) => {
        return memo.concat({ name: key, group: JSON.parse(value).version });
      }, []);

    tests = document.cookie
      .split(';')
      .map((item) => {
        const [_key, value] = item.split('=');
        const key = _key.trim();

        return { key, value };
      })
      .reduce((memo, { key, value }) => {
        if (!key.startsWith('test-')) return memo;

        return memo.concat({
          name: key,
          group: JSON.parse(decodeURIComponent(value)).version,
        });
      }, tests);

    const data = Object.assign(
      {
        needsLogin: false,
        loggedIn: false,
      },
      dataLayerArgs,
      {
        tests: tests,
      },
    );

    globalThis.dataLayer.push(data);
  } catch {
    // eslint-disable-next-line no-console
    console.warn('Unable to initialize GTM onload data');
  }
};
